export default "__VITE_ASSET__05d31f18__"